"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = _interopRequireDefault(require("@ahmdigital/constants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var agrIncomeThresholdsKeyedByDate = {
  '2018-04-01T00:00:00+10:00': _defineProperty(_defineProperty({}, _constants["default"].INCOME_TYPE.SINGLE, [{
    min: 0,
    max: 90000,
    rate: 0,
    incomeTier: _constants["default"].INCOME_TIER.TIER_0
  }, {
    min: 90001,
    max: 105000,
    rate: 1,
    incomeTier: _constants["default"].INCOME_TIER.TIER_1
  }, {
    min: 105001,
    max: 140000,
    rate: 1.25,
    incomeTier: _constants["default"].INCOME_TIER.TIER_2
  }, {
    min: 140001,
    max: Number.MAX_VALUE,
    rate: 1.5,
    incomeTier: _constants["default"].INCOME_TIER.TIER_3
  }]), _constants["default"].INCOME_TYPE.COUPLE, [{
    min: 0,
    max: 180000,
    rate: 0,
    incomeTier: _constants["default"].INCOME_TIER.TIER_0
  }, {
    min: 180001,
    max: 210000,
    rate: 1,
    incomeTier: _constants["default"].INCOME_TIER.TIER_1
  }, {
    min: 210001,
    max: 280000,
    rate: 1.25,
    incomeTier: _constants["default"].INCOME_TIER.TIER_2
  }, {
    min: 280001,
    max: Number.MAX_VALUE,
    rate: 1.5,
    incomeTier: _constants["default"].INCOME_TIER.TIER_3
  }]),
  '2023-07-01T00:00:00+10:00': _defineProperty(_defineProperty({}, _constants["default"].INCOME_TYPE.SINGLE, [{
    min: 0,
    max: 93000,
    rate: 0,
    incomeTier: _constants["default"].INCOME_TIER.TIER_0
  }, {
    min: 93001,
    max: 108000,
    rate: 1,
    incomeTier: _constants["default"].INCOME_TIER.TIER_1
  }, {
    min: 108001,
    max: 144000,
    rate: 1.25,
    incomeTier: _constants["default"].INCOME_TIER.TIER_2
  }, {
    min: 144001,
    max: Number.MAX_VALUE,
    rate: 1.5,
    incomeTier: _constants["default"].INCOME_TIER.TIER_3
  }]), _constants["default"].INCOME_TYPE.COUPLE, [{
    min: 0,
    max: 186000,
    rate: 0,
    incomeTier: _constants["default"].INCOME_TIER.TIER_0
  }, {
    min: 186001,
    max: 216000,
    rate: 1,
    incomeTier: _constants["default"].INCOME_TIER.TIER_1
  }, {
    min: 216001,
    max: 288000,
    rate: 1.25,
    incomeTier: _constants["default"].INCOME_TIER.TIER_2
  }, {
    min: 288001,
    max: Number.MAX_VALUE,
    rate: 1.5,
    incomeTier: _constants["default"].INCOME_TIER.TIER_3
  }]),
  '2024-07-01T00:00:00+10:00': _defineProperty(_defineProperty({}, _constants["default"].INCOME_TYPE.SINGLE, [{
    min: 0,
    max: 97000,
    rate: 0,
    incomeTier: _constants["default"].INCOME_TIER.TIER_0
  }, {
    min: 97001,
    max: 113000,
    rate: 1,
    incomeTier: _constants["default"].INCOME_TIER.TIER_1
  }, {
    min: 113001,
    max: 151000,
    rate: 1.25,
    incomeTier: _constants["default"].INCOME_TIER.TIER_2
  }, {
    min: 151001,
    max: Number.MAX_VALUE,
    rate: 1.5,
    incomeTier: _constants["default"].INCOME_TIER.TIER_3
  }]), _constants["default"].INCOME_TYPE.COUPLE, [{
    min: 0,
    max: 194000,
    rate: 0,
    incomeTier: _constants["default"].INCOME_TIER.TIER_0
  }, {
    min: 194001,
    max: 226000,
    rate: 1,
    incomeTier: _constants["default"].INCOME_TIER.TIER_1
  }, {
    min: 226001,
    max: 302000,
    rate: 1.25,
    incomeTier: _constants["default"].INCOME_TIER.TIER_2
  }, {
    min: 302001,
    max: Number.MAX_VALUE,
    rate: 1.5,
    incomeTier: _constants["default"].INCOME_TIER.TIER_3
  }]),
  '2025-07-01T00:00:00+10:00': _defineProperty(_defineProperty({}, _constants["default"].INCOME_TYPE.SINGLE, [{
    min: 0,
    max: 101000,
    rate: 0,
    incomeTier: _constants["default"].INCOME_TIER.TIER_0
  }, {
    min: 101001,
    max: 118000,
    rate: 1,
    incomeTier: _constants["default"].INCOME_TIER.TIER_1
  }, {
    min: 118001,
    max: 158000,
    rate: 1.25,
    incomeTier: _constants["default"].INCOME_TIER.TIER_2
  }, {
    min: 158001,
    max: Number.MAX_VALUE,
    rate: 1.5,
    incomeTier: _constants["default"].INCOME_TIER.TIER_3
  }]), _constants["default"].INCOME_TYPE.COUPLE, [{
    min: 0,
    max: 202000,
    rate: 0,
    incomeTier: _constants["default"].INCOME_TIER.TIER_0
  }, {
    min: 202001,
    max: 236000,
    rate: 1,
    incomeTier: _constants["default"].INCOME_TIER.TIER_1
  }, {
    min: 236001,
    max: 316000,
    rate: 1.25,
    incomeTier: _constants["default"].INCOME_TIER.TIER_2
  }, {
    min: 316001,
    max: Number.MAX_VALUE,
    rate: 1.5,
    incomeTier: _constants["default"].INCOME_TIER.TIER_3
  }])
};
var _default = exports["default"] = agrIncomeThresholdsKeyedByDate;
module.exports = exports.default;